// Generated by ReScript, PLEASE EDIT WITH CARE


function isRequested(value) {
  if (typeof value !== "object") {
    return value === "Requested";
  } else {
    return false;
  }
}

function isSucceeded(value) {
  if (typeof value !== "object") {
    return false;
  } else {
    return value.TAG === "Succeeded";
  }
}

export {
  isRequested,
  isSucceeded,
}
/* No side effect */
